/**
 * Parses JSONL/NDJSON content into a FHIR Bundle.
 * Each non-empty line is expected to be a JSON-encoded FHIR resource.
 * Lines that fail to parse are skipped and reported in the errors array.
 */
interface FHIRBundle {
  resourceType: string;
  type: string;
  entry: Array<{ resource: Record<string, unknown> }>;
}

export function parseJSONLToFHIRBundle(text: string): { bundle: FHIRBundle; errors: string[] } {
  const lines = text.split('\n');
  const entries: Array<{ resource: Record<string, unknown> }> = [];
  const errors: string[] = [];

  lines.forEach((line, index) => {
    const trimmed = line.trim();
    if (!trimmed) return;

    try {
      const resource = JSON.parse(trimmed);
      if (resource.resourceType) {
        entries.push({ resource });
      } else {
        errors.push(`Line ${index + 1}: missing resourceType`);
      }
    } catch (e) {
      errors.push(`Line ${index + 1}: invalid JSON`);
    }
  });

  const bundle = {
    resourceType: 'Bundle',
    type: 'collection',
    entry: entries,
  };

  return { bundle, errors };
}
